"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const addTeamMemberConstants = {
  USEREMAIL: 'userEmail',
  SRC_BUSINESS_ENTITY_NAME: 'businessEntityName',
  BUSINESS_ENTITY_NAME: 'businessEntityName',
  SELECT_MINE_SITES: 'SELECT <MineSiteLabelPlural>',
  SELECT_APP_ROLE_PLACEHOLDER: 'Select app role',
  SELECT_APP_ROLE_TITLE: 'SELECT APP ROLE',
  SELECT_MINE_SITES_TITLE: 'ASSIGN USERS TO <MineSiteLabel>',
  SELECT_MINE_SITES_PLACEHOLDER: 'Enter <MineSiteLabel> names seperated by a comma',
  REQUIRED: 'Required',
  PRIMARY: 'primary',
  MEDIUM: 'medium',
  NOT_FOUND: 'Not Found'
};
var _default = exports.default = addTeamMemberConstants;